import {
  ACTION_TYPE_CLICK,
  ACTION_TYPE_DISPLAY,
  ELEMENT_TYPE_VIEW_MORE,
  ELEMENT_TYPE_CONTAINER,
  ELEMENT_TYPE_TITLE,
  ELEMENT_TYPE_CATEGORY,
  EXECUTE_TYPE_LANDING,
  EXECUTE_TYPE_PLAY,
  EXECUTE_TYPE_FETCH,
  EXECUTE_TYPE_TOGGLE,
} from '@/common/normalize/const'

// Note: Node Structure : element -> action -> execute

/**
 * return type VIEW MORE from element list
 * @param element
 * @returns {boolean}
 */
export const isElementTypeViewMore = (element) => {
  return element?.type === ELEMENT_TYPE_VIEW_MORE
}

/**
 * return type CONTAINER from element list
 * @param element
 * @returns {boolean}
 */
export const isElementTypeContainer = (element) => {
  return element?.type === ELEMENT_TYPE_CONTAINER
}

export const isElementTypeCategory = (element) => {
  return element?.type === ELEMENT_TYPE_CATEGORY
}

/**
 * return type TITLE from element list
 * @param element
 * @returns {boolean}
 */
export const isElementTypeTitle = (element) => {
  return element?.type === ELEMENT_TYPE_TITLE
}

/**
 * return CLICK from action list
 * @param action
 * @returns {boolean}
 */
export const isActionTypeClick = (action) => {
  return action.type === ACTION_TYPE_CLICK
}

/**
 * return DISPLAY from action list
 * @param action
 * @returns {boolean}
 */
export const isActionTypeDisplay = (action) => {
  return action.type === ACTION_TYPE_DISPLAY
}

/**
 * return LANDING from execute object
 * @param action
 * @returns {boolean}
 */
export const isExecuteTypeLanding = (action) => {
  return action?.execute?.type === EXECUTE_TYPE_LANDING
}

/**
 * return PLAY from execute object
 * @param action
 * @returns {boolean}
 */
export const isExecuteTypePlay = (action) => {
  return action?.execute?.type === EXECUTE_TYPE_PLAY
}

/**
 * return FETCH from execute object
 * @param action
 * @returns {boolean}
 */
export const isExecuteTypeFetch = (action) => {
  return action?.execute?.type === EXECUTE_TYPE_FETCH
}

/**
 * return TOGGLE from execute object
 * @param action
 * @returns {boolean}
 */
export const isExecuteTypeToggle = (action) => {
  return action?.execute?.type === EXECUTE_TYPE_TOGGLE
}
